import router from '@/router';
import { getAngularProvider, safeDigest } from 'services/utils/angularUtils';

export const navigateToAngularRoute = async (path, { query, params } = {}) => {
    // some magic is happening here, when not sending success/fail callbacks route sometimes mysteriously reverts
    await router.push({ path, query, params }, () => {}, () => {});
    safeDigest();
};

export const navigateToAngularState = async (state, stateParams) => {
    if (!window.angular) return;
    await router.replace('/');
    const $state = getAngularProvider('$state');
    $state.go(state, stateParams);
};
